import useAuth from './useAuth'
import useScreen from './useScreen'

const useIntercom = () => {
    const intercomAppId = process.env.MIX_APP_INTERCOM_ID
    const environment = process.env.MIX_APP_NAME
    const { isMobile } = useScreen()

    const { user, role, impersonated, authenticated: isLoggedIn } = useAuth()

    const isUser = isLoggedIn && role === 'user'
    const isManager = isLoggedIn && role === 'manager'
    const isStandardUser = isUser || isManager

    const loadIntercom = () => {
        if (isStandardUser && window.Intercom != null) {
            if (impersonated) {
                window.Intercom('boot', {
                    app_id: intercomAppId,
                })
            } else {
                window.Intercom('boot', {
                    user_id: user?.id,
                    name: user?.first_name + ' ' + user?.last_name,
                    email: user?.email,
                    phone: user?.phone,
                    company: {
                        company_id: user?.company.external_id,
                        name: user?.company.name,
                    },
                    environment: environment,
                    app_id: intercomAppId,
                    hide_default_launcher: isMobile, //This will make the Intercom invisible when mobile
                })
            }
        }
    }

    const bootIntercomForGuest = () => {
        if (window.Intercom != null) {
            window.Intercom('boot', {
                app_id: intercomAppId,
            })
        }
    }

    const intercomSendMessage = message => {
        if (window?.Intercom != null) {
            window?.Intercom('showNewMessage', message)
        }
    }

    return {
        loadIntercom,
        intercomSendMessage,
        bootIntercomForGuest,
    }
}

export default useIntercom
